<template>
  <div class="package-footer">
    <div class="footer-background-shapes">
      <div class="bg-circle circle-1"></div>
      <div class="bg-circle circle-2"></div>
      <div class="bg-triangle triangle-1"></div>
      <div class="bg-triangle triangle-2"></div>
      <div class="bg-hexagon hexagon-1"></div>
    </div>

    <div class="footer-content">
      <div class="footer-header">
        <h3 class="footer-title">Complete Home Care Services</h3>
        <p class="footer-subtitle">
          Professional maintenance and cleaning solutions for your entire home
        </p>
      </div>

      <div class="services-grid">
        <div
          class="service-item"
          v-for="(service, index) in services"
          :key="index"
          :style="{ 'animation-delay': `${index * 0.1}s` }"
        >
          <div class="service-icon">
            <div class="icon-background"></div>
            <i :class="service.icon"></i>
            <div class="icon-pulse"></div>
          </div>
          <div class="service-content">
            <h4 class="service-name">{{ service.name }}</h4>
            <p class="service-description">{{ service.description }}</p>
          </div>
        </div>
      </div>

      <div class="coverage-info">
        <div class="coverage-card">
          <div class="coverage-icon">
            <i class="mdi mdi-home-variant"></i>
          </div>
          <div class="coverage-details">
            <h4 class="coverage-title">Coverage Area</h4>
            <p class="coverage-text">Up to 2,100 sq ft included</p>
            <span class="coverage-note">Additional charges apply for larger spaces</span>
          </div>
        </div>

        <div class="coverage-card">
          <div class="coverage-icon">
            <i class="mdi mdi-map-marker-radius"></i>
          </div>
          <div class="coverage-details">
            <h4 class="coverage-title">Service Locations</h4>
            <p class="coverage-text">All Kerala Districts</p>
            <span class="coverage-note">Professional service across the state</span>
          </div>
        </div>
      </div>

      <div class="floating-elements">
        <div class="float-shape shape-1"></div>
        <div class="float-shape shape-2"></div>
        <div class="float-shape shape-3"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ServicesCoverageFooter',
  data() {
    return {
      services: [
        {
          name: 'Home Deep Cleaning',
          description: 'Comprehensive cleaning of all rooms, surfaces, and hard-to-reach areas',
          icon: 'mdi mdi-broom',
        },
        {
          name: 'Pest Control Service',
          description: 'Professional pest elimination and prevention treatments',
          icon: 'mdi mdi-bug',
        },
        {
          name: 'Inspection & Maintenance',
          description: 'Regular home systems check and preventive maintenance',
          icon: 'mdi mdi-clipboard-check',
        },
        {
          name: 'Reorganization & Decluttering',
          description: 'Space optimization and organized storage solutions',
          icon: 'mdi mdi-folder-open',
        },
        {
          name: 'AC Servicing',
          description: 'Complete air conditioning maintenance and repair services',
          icon: 'mdi mdi-air-conditioner',
        },
        {
          name: 'Furniture & Upholstery',
          description: 'Professional cleaning and restoration of furniture pieces',
          icon: 'mdi mdi-sofa',
        },
        {
          name: 'Electrical Check',
          description: 'Safety inspection and maintenance of electrical systems',
          icon: 'mdi mdi-lightning-bolt',
        },
        {
          name: 'Plumbing Check',
          description: 'Comprehensive plumbing inspection and minor repairs',
          icon: 'mdi mdi-pipe-wrench',
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      // Intersection Observer for footer elements
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('animate-in');
            }
          });
        },
        { threshold: 0.1 }
      );
      document.querySelectorAll('.package-footer, .service-item, .coverage-card').forEach((el) => {
        observer.observe(el);
      });
    });
  },
};
</script>

<style scoped>
.package-footer {
  position: relative;
  opacity: 0;
  transform: translateY(60px);
}

.package-footer.animate-in {
  animation: fadeInUp 1s ease-out 0.6s forwards;
}

.footer-background-shapes {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(244, 101, 35, 0.03), rgba(255, 138, 0, 0.03));
  animation: floatSlow 8s ease-in-out infinite;
}

.circle-1 {
  width: 120px;
  height: 120px;
  top: 10%;
  left: 5%;
  animation-delay: 0s;
}

.circle-2 {
  width: 80px;
  height: 80px;
  top: 60%;
  right: 8%;
  animation-delay: 2s;
}

.bg-triangle {
  position: absolute;
  width: 0;
  height: 0;
  animation: floatSlow 10s ease-in-out infinite;
}

.triangle-1 {
  border-left: 30px solid transparent;
  border-right: 30px solid transparent;
  border-bottom: 50px solid rgba(244, 101, 35, 0.04);
  top: 20%;
  right: 15%;
  animation-delay: 1s;
}

.triangle-2 {
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 35px solid rgba(59, 130, 246, 0.04);
  bottom: 25%;
  left: 10%;
  animation-delay: 3s;
}

.bg-hexagon {
  position: absolute;
  width: 40px;
  height: 40px;
  background: rgba(244, 101, 35, 0.05);
  clip-path: polygon(30% 0%, 70% 0%, 100% 50%, 70% 100%, 30% 100%, 0% 50%);
  animation: floatSlow 12s ease-in-out infinite;
}

.hexagon-1 {
  top: 75%;
  right: 25%;
  animation-delay: 4s;
}

.footer-content {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(25px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 32px;
  padding: 64px 48px;
  position: relative;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.06),
    0 8px 25px rgba(244, 101, 35, 0.04);
  overflow: hidden;
}

.footer-header {
  text-align: center;
  margin-bottom: 56px;
}

.footer-title {
  font-size: 36px;
  font-weight: 800;
  background: linear-gradient(135deg, #f46523 0%, #ff8a00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 16px;
  letter-spacing: -0.02em;
}

.footer-subtitle {
  font-size: 18px;
  color: #64748b;
  font-weight: 400;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  margin-bottom: 64px;
}

.service-item {
  text-align: center;
  opacity: 0;
  transform: translateY(40px) scale(0.9);
  transition: transform 0.3s ease;
}

.service-item.animate-in {
  animation: serviceSlideIn 0.8s ease-out forwards;
}

.service-item:hover {
  transform: translateY(-8px) scale(1.05);
}

.service-icon {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(244, 101, 35, 0.1), rgba(255, 138, 0, 0.1));
  border-radius: 20px;
  transition: transform 0.3s ease;
}

.service-item:hover .icon-background {
  transform: rotate(10deg) scale(1.1);
}

.service-icon i {
  font-size: 36px;
  color: #f46523;
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease;
}

.service-item:hover .service-icon i {
  transform: scale(1.2);
}

.icon-pulse {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(244, 101, 35, 0.2), rgba(255, 138, 0, 0.2));
  border-radius: 20px;
  opacity: 0;
  animation: pulse 2s ease-in-out infinite;
}

.service-name {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.service-description {
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
  font-weight: 400;
}

.coverage-info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
}

.coverage-card {
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 32px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(30px);
}

.coverage-card.animate-in {
  animation: fadeInUp 0.8s ease-out 1s forwards;
}

.coverage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(244, 101, 35, 0.08);
}

.coverage-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #f46523, #ff9800);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.coverage-icon i {
  font-size: 28px;
}

.coverage-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
}

.coverage-text {
  font-size: 16px;
  font-weight: 600;
  color: #f46523;
  margin-bottom: 4px;
}

.coverage-note {
  font-size: 14px;
  color: #64748b;
  font-weight: 400;
}

.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.float-shape {
  position: absolute;
  background: rgba(244, 101, 35, 0.05);
  animation: floatSlow 6s ease-in-out infinite;
}

.shape-1 {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  top: 15%;
  right: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 16px;
  height: 16px;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  top: 70%;
  left: 15%;
  animation-delay: 2s;
}

.shape-3 {
  width: 24px;
  height: 24px;
  transform: rotate(45deg);
  top: 40%;
  right: 5%;
  animation-delay: 4s;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes serviceSlideIn {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes floatSlow {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  33% {
    transform: translateY(-15px) rotate(5deg);
  }
  66% {
    transform: translateY(-8px) rotate(-3deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

@media (max-width: 992px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }

  .footer-content {
    padding: 48px 36px;
  }

  .footer-title {
    font-size: 32px;
  }
}

@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 48px;
  }

  .coverage-info {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .footer-content {
    padding: 40px 28px;
  }

  .footer-title {
    font-size: 28px;
  }

  .footer-subtitle {
    font-size: 16px;
  }

  .service-icon {
    width: 70px;
    height: 70px;
  }

  .service-icon i {
    font-size: 32px;
  }

  .service-name {
    font-size: 16px;
  }

  .service-description {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .services-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 40px;
  }

  .service-item {
    display: flex;
    align-items: center;
    text-align: left;
    gap: 16px;
  }

  .service-icon {
    width: 60px;
    height: 60px;
    margin: 0;
  }

  .service-icon i {
    font-size: 24px;
  }

  .footer-content {
    padding: 32px 20px;
  }

  .footer-title {
    font-size: 24px;
  }

  .footer-subtitle {
    font-size: 15px;
  }

  .coverage-card {
    padding: 24px 20px;
    gap: 16px;
  }

  .coverage-icon {
    width: 50px;
    height: 50px;
  }

  .coverage-icon i {
    font-size: 24px;
  }

  .coverage-title {
    font-size: 18px;
  }

  .coverage-text {
    font-size: 15px;
  }

  .coverage-note {
    font-size: 13px;
  }
}
</style>
